export const shared = {
  hashtag: 'No',
  confirm: '確認',
  itemNotFound: 'データがありません',
  selectPlaceholder: '選択',
  itemPager: ' 件',
  titleNotify: '通知',
  index: '番号',
  profile: 'プロフィール',
  status: 'ステータス',
  create: '新規作成',
  update: '更新',
  date: '日付',
  note: 'メモ',
  notItems: 'データがありません',
  action: 'アクション',
};
